import { c as _c } from "react/compiler-runtime";
import React from "react";
import DropPartMarkdownWithPropLogger from "@/components/drops/view/part/DropPartMarkdownWithPropLogger";
import WaveDropQuoteWithDropId from "./WaveDropQuoteWithDropId";
import EditDropLexical from "./EditDropLexical";
import type { ApiDropMentionedUser } from "@/generated/models/ApiDropMentionedUser";
import type { ApiDropReferencedNFT } from "@/generated/models/ApiDropReferencedNFT";
import type { ApiDropPart } from "@/generated/models/ApiDropPart";
import type { ApiWaveMin } from "@/generated/models/ApiWaveMin";
import type { ApiDrop } from "@/generated/models/ApiDrop";
interface WaveDropPartContentMarkdownProps {
  readonly mentionedUsers: Array<ApiDropMentionedUser>;
  readonly referencedNfts: Array<ApiDropReferencedNFT>;
  readonly part: ApiDropPart;
  readonly wave: ApiWaveMin;
  readonly onQuoteClick: (drop: ApiDrop) => void;
  readonly isEditing?: boolean | undefined;
  readonly isSaving?: boolean | undefined;
  readonly onSave?: ((newContent: string, mentions?: ApiDropMentionedUser[]) => void) | undefined;
  readonly onCancel?: (() => void) | undefined;
  readonly drop?: ApiDrop | undefined; // Add drop to check for edited status
}
const WaveDropPartContentMarkdown: React.FC<WaveDropPartContentMarkdownProps> = t0 => {
  const $ = _c(29);
  const {
    mentionedUsers,
    referencedNfts,
    part,
    wave,
    onQuoteClick,
    isEditing: t1,
    isSaving: t2,
    onSave,
    onCancel,
    drop
  } = t0;
  const isEditing = t1 === undefined ? false : t1;
  const isSaving = t2 === undefined ? false : t2;
  if (isEditing) {
    const t3 = part.content ?? "";
    let t4;
    if ($[0] !== onSave) {
      t4 = (content, mentions) => {
        if (onSave) {
          onSave(content, mentions);
        }
      };
      $[0] = onSave;
      $[1] = t4;
    } else {
      t4 = $[1];
    }
    let t5;
    if ($[2] !== onCancel) {
      t5 = () => {
        if (onCancel) {
          onCancel();
        }
      };
      $[2] = onCancel;
      $[3] = t5;
    } else {
      t5 = $[3];
    }
    let t6;
    if ($[4] !== isSaving || $[5] !== mentionedUsers || $[6] !== t3 || $[7] !== t4 || $[8] !== t5 || $[9] !== wave.id) {
      t6 = <EditDropLexical initialContent={t3} initialMentions={mentionedUsers} waveId={wave.id} isSaving={isSaving} onSave={t4} onCancel={t5} />;
      $[4] = isSaving;
      $[5] = mentionedUsers;
      $[6] = t3;
      $[7] = t4;
      $[8] = t5;
      $[9] = wave.id;
      $[10] = t6;
    } else {
      t6 = $[10];
    }
    return t6;
  }
  const t3 = drop?.id;
  let t4;
  if ($[11] !== mentionedUsers || $[12] !== onQuoteClick || $[13] !== part.content || $[14] !== referencedNfts || $[15] !== t3) {
    t4 = <DropPartMarkdownWithPropLogger mentionedUsers={mentionedUsers} referencedNfts={referencedNfts} partContent={part.content} onQuoteClick={onQuoteClick} currentDropId={t3} />;
    $[11] = mentionedUsers;
    $[12] = onQuoteClick;
    $[13] = part.content;
    $[14] = referencedNfts;
    $[15] = t3;
    $[16] = t4;
  } else {
    t4 = $[16];
  }
  let t5;
  if ($[17] !== drop) {
    t5 = drop?.updated_at && drop.updated_at !== drop.created_at && <div className="tw-text-[10px] tw-leading-none tw-text-iron-500 tw-font-normal tw-mt-0.5">(edited)</div>;
    $[17] = drop;
    $[18] = t5;
  } else {
    t5 = $[18];
  }
  let t6;
  if ($[19] !== t4 || $[20] !== t5) {
    t6 = <div>{t4}{t5}</div>;
    $[19] = t4;
    $[20] = t5;
    $[21] = t6;
  } else {
    t6 = $[21];
  }
  let t7;
  if ($[22] !== onQuoteClick || $[23] !== part.quoted_drop || $[24] !== wave) {
    t7 = part.quoted_drop?.drop_id && <div className="tw-mt-1.5"><WaveDropQuoteWithDropId dropId={part.quoted_drop.drop_id} partId={part.quoted_drop.drop_part_id} maybeDrop={part.quoted_drop.drop ? {
        ...part.quoted_drop.drop,
        wave
      } : null} onQuoteClick={onQuoteClick} /></div>;
    $[22] = onQuoteClick;
    $[23] = part.quoted_drop;
    $[24] = wave;
    $[25] = t7;
  } else {
    t7 = $[25];
  }
  let t8;
  if ($[26] !== t6 || $[27] !== t7) {
    t8 = <>{t6}{t7}</>;
    $[26] = t6;
    $[27] = t7;
    $[28] = t8;
  } else {
    t8 = $[28];
  }
  return t8;
};
export default WaveDropPartContentMarkdown;